import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import { setSelectedCourse } from 'reducers/activecourse/activecourseSlice'
import { useAppDispatch } from 'hooks/store'
import { CourseInviteProvider, CoursePaymentType } from 'share/domain/course'
import {
  CourseCardContent,
  CourseCardHeader,
  CourseCardPrice,
  StyledCard,
  StyledCardFooter
} from 'components/atoms/StyledCard'

import FormattedPrice from 'components/atoms/FormattedPrice'

import { CoursesProviderCardsWrapper, CoursesProviderInfoText } from './styles'

interface CourseTabProviderDisplayProps {
  coursePaymentType: CoursePaymentType
  courseProviderList: CourseInviteProvider[]
}

interface History {
  businessObjectId?: number | null
  businessObjectType?: string
  caseId?: number
  coursePaymentType?: CoursePaymentType
  courseProviderList?: CourseInviteProvider[]
  navFromCourses?: boolean
  type?: string
}

const CourseTabPlaceOrderChooseCourseForm: FC<CourseTabProviderDisplayProps> =
  ({ coursePaymentType, courseProviderList }) => {
    const history = useHistory<History>()
    const dispatch = useAppDispatch()

    function handleTakeCourseOnline(selectedCourse: CourseInviteProvider) {
      dispatch(setSelectedCourse(selectedCourse))
      history.push({
        pathname: '/dashboard/courses/confirm',
        state: {
          type: 'online',
          coursePaymentType,
          courseProviderList
        }
      })
    }

    function handleTakeCourseByPhone(selectedCourse: CourseInviteProvider) {
      console.log('handleTakeCourseByPhone ', selectedCourse.productKey)
      dispatch(setSelectedCourse(selectedCourse))
      history.push({
        pathname: '/dashboard/courses/confirm',
        state: {
          type: 'phone',
          coursePaymentType,
          courseProviderList
        }
      })
    }

    return (
      <div data-testid='course-tab-choose-course-content'>
        {coursePaymentType === CoursePaymentType.ClientPays &&
          courseProviderList.length > 0 && (
            <CoursesProviderInfoText data-testid='course-tab-choose-course-clientpays-title'>
              Choose from the providers listed below
            </CoursesProviderInfoText>
          )}
        <CoursesProviderCardsWrapper data-testid='course-tab-choose-course-card-wrapper'>
          {courseProviderList.map((courseProvider, index) => (
            <StyledCard key={courseProvider.productKey}>
              <Card.Body>
                <CourseCardHeader>
                  <h4
                    data-testid={`course-tab-choose-course-provider-name-${index}`}
                  >
                    {courseProvider.name}
                  </h4>
                  <CourseCardPrice>
                    <p>Course Price</p>
                    {coursePaymentType === CoursePaymentType.ClientPays && (
                      <span
                        data-testid={`course-tab-choose-course-clientpays-price-${index}`}
                      >
                        <FormattedPrice price={courseProvider.price} />
                      </span>
                    )}
                    {coursePaymentType === CoursePaymentType.FirmPays && (
                      <span
                        className='long'
                        data-testid={`course-tab-choose-course-firmpays-price-${index}`}
                      >
                        Billed to Law Firm
                      </span>
                    )}
                  </CourseCardPrice>
                </CourseCardHeader>
                {courseProvider.valueProps && (
                  <CourseCardContent
                    dangerouslySetInnerHTML={{
                      __html: courseProvider.valueProps.toString()
                    }}
                    data-testid={`courses-course-value-props-${index}`}
                  />
                )}
              </Card.Body>
              <StyledCardFooter>
                <Button
                  data-testid={`courses-course-take-course-online-button-${index}`}
                  variant='outline-secondary'
                  onClick={() => handleTakeCourseOnline(courseProvider)}
                >
                  Take Course Online
                </Button>
                <Button
                  data-testid={`courses-course-take-course-by-phone-button-${index}`}
                  variant='link'
                  onClick={() => handleTakeCourseByPhone(courseProvider)}
                >
                  Take Course By Phone Call
                </Button>
              </StyledCardFooter>
            </StyledCard>
          ))}
        </CoursesProviderCardsWrapper>
      </div>
    )
  }

export default CourseTabPlaceOrderChooseCourseForm
